import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import rootReducer from '../reducers';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
      serializable: false,
      serializableError: false,
      immutableError: false,
    }),
});

const StoreProvider = ({ children }) => <Provider store={store}>{children}</Provider>;

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StoreProvider;
